import { observer } from 'mobx-react';
import Counter3_0 from './Counter3_0';
import Counter3_1 from './Counter3_1';
import Counter3_2 from './Counter3_2';
import Counter3_3 from './Counter3_3';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  utilized: number;
}

function ThreeOfferingTypes({ utilized }: Props) {
  switch (utilized) {
    case 0:
      return <Counter3_0 />;
    case 1:
      return <Counter3_1 />;
    case 2:
      return <Counter3_2 />;
    case 3:
      return <Counter3_3 />;
    default:
      return emptyFragment();
  }
}

export default observer(ThreeOfferingTypes);
